const styles = () => ({
  link: {
    display: 'inline-block',
  },
})

export default styles
